<template>
  <div
    class="login-page h-screen flex w-full vx-row no-gutter items-center justify-center bg-img"
    id="page-login"
  >
    <div class="vx-col xs:w-1 sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
      <vx-card style="background-color:#fff;">
        <LoginForm />
      </vx-card>
    </div>
  </div>
</template>


<script>

import LoginForm from './LoginForm'
export default {

  //components
  components: {
    LoginForm,
  },
  methods: {
    toRegister () {
      this.$router.push('/register')
    },
  }
}
</script>

<style lang="scss">
.login-page {
  .login-bg-container {
    // min-height: 460px;
    // background-color: rgba(0, 0, 0, 0);
    position: relative;
    .login-form {
      width: 260px;
      height: 380px;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
// .emoji-container {
//   display: block !important;
// }
</style>
